import { useEffect } from "react";
import type { EffectCallback, DependencyList } from "react";

// https://dev.to/rajeshroyal/how-to-make-a-custom-debounce-hook-in-react-js-4gcc

export const useDebounce =
  (delay: number) => (effect: EffectCallback, deps?: DependencyList) =>
    useEffect(() => {
      const handler = setTimeout(effect, delay)

      return () => clearTimeout(handler)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...deps, delay])